module.exports = __webpack_public_path__ + "static/media/frame_70.b874ba2a.jpg";